import React, { useRef } from 'react';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment/moment';
import { useReactToPrint } from 'react-to-print';
import { CSVLink } from 'react-csv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons';
//Components
import MainCard from '../../../components/MainCard/MainCard';
import CardRelatorio from '../components/CardRelatorio';

//Context
import { useAuth } from 'context/auth';

export default function RelatorioColetasResumido({ dadosRelatorio, btnVoltar, filtros }) {
    const { session, setupVariavel } = useAuth();

    //Referencia do relatorio para download do csv
    const exportRef = useRef(null);

    //Botão de exportação csv
    const BtnExportCsv = () => {
        return (
            <Button className='mb-3' color='success' onClick={() => exportRef.current.link.click()}>
                <FontAwesomeIcon icon={faFileCsv} /> Gerar CSV
            </Button>
        )
    }
    //Referencia para a impressão pdf
    const refRelatorio = useRef();

    //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
    const headersColetas = [
        { value: `Nº ${setupVariavel?.siglaDocumentoColeta}`, objectValue: "item_Coleta", col: "4" },
        { value: "RAMO DE ATIVIDADE", objectValue: "segmento", col: "4" },
        { value: "REGIONAL", objectValue: "regional", col: "4" },

        { value: "MODALIDADE DE COLETA", objectValue: "tipo_Coleta", col: "12" },
        { value: "RESÍDUOS", objectValue: "residuo", col: "12" },

        { value: "DATA/HORA DA COLETA", objectValue: "data_Coleta", formatDate: true, col: "8" },
        { value: "COLETADO", objectValue: "volume", col: "4" },
        { value: "DATA/HORA DO RECEBIMENTO", objectValue: "data_Descarte", formatDate: true, col: "12" },

        { value: "STATUS", objectValue: "status_Coleta", col: "4" },
        { value: "MOTIVO NÃO COLETA", objectValue: "motivo_Nao_Coleta", col: "8" },
        { value: "CNPJ", objectValue: "cpfcnpj", col: "12" },
        { value: "NOME DO GERADOR", objectValue: "nome_Gerado", col: "12" },

        { value: "ENDEREÇO", objectValue: "local_Coleta", col: "12" },
    ];
    //Headers para exportar csv
    const headersExport = [
        { key: "bairro", label: "BAIRRO" },
        { key: "cep", label: "CEP" },
        { key: "cidade", label: "CIDADE" },
        { key: "cnpJ_Transportador", label: "CNPJ DO TRANSPORTADOR" },
        { key: "contato", label: "CONTATO" },
        { key: "contato_Destino", label: "CONTATO DO DESTINO" },
        { key: "contato_Transportador", label: "CONTATO DO TRANSPORTADOR" },
        { key: "contrato", label: "CONTRATO" },
        { key: "cpfcnpj", label: "CPF/CNPJ" },
        { key: "data_Coleta", label: "DATA DA COLETA" },
        { key: "data_Descarte", label: "DATA DO DESCARTE" },
        { key: "data_Roteiro", label: "DATA DO ROTEIRO" },
        { key: "destino", label: "DESTINO" },
        { key: "email", label: "E-MAIL" },
        { key: "endereco_Destino", label: "ENDEREÇO DO DESTINO" },
        { key: "endereco_Transportador", label: "ENDERECO DO TRANSPORTADOR" },
        { key: "fone", label: "FONE" },
        { key: "fone_Destino", label: "FONE DO DESTINO" },
        { key: "item_Coleta", label: `Nº ${setupVariavel?.siglaDocumentoColeta}` },
        { key: "local_Coleta", label: "LOCAL DA COLETA" },
        { key: "logradouro", label: "LOGRADOURO" },
        { key: "motivo_Nao_Coleta", label: "MOTIVO DA NÃO COLETA" },
        { key: "nome_Destino", label: "NOME DO DESTINO" },
        { key: "nome_Gerado", label: "NOME DO GERADOR" },
        { key: "nome_Transportador", label: "NOME DO TRANSPORTADOR" },
        { key: "numero", label: "NUMERO" },
        { key: "pesoDestinado", label: "PESO DESTINADO" },
        { key: "pesoEntrada", label: "PESO DE ENTRADA" },
        { key: "placaImplemento", label: "PLACA/IMPLEMENTO" },
        { key: "recipiente", label: "RECIPIENT" },
        { key: "regional", label: "REGIONAL" },
        { key: "residuo", label: "RESIDUO" },
        { key: "responsavel", label: "RESPONSAVEL" },
        { key: "responsavel_Destino", label: "RESPONSAVEL DO DESTINO" },
        { key: "segmento", label: "SEGMENTO" },
        { key: "setor_Coleta", label: "SETOR DA COLETA" },
        { key: "status_Coleta", label: "STATUS DA COLETA" },
        { key: "taG_Recipiente", label: "TAG" },
        { key: "tipo_Coleta", label: "TIPO DA COLETA" },
        { key: "tipo_Destino", label: "TIPO DO DESTINO" },
        { key: "tipo_Veiculo", label: "TIPO DO VEICULO" },
        { key: "uf", label: "UF" },
        { key: "unidade", label: "UNIDADE DE MEDIDA" },
        { key: "veiculo", label: "VEICULO" },
        { key: "volume", label: "VOLUME" },
        { key: "volumetria", label: "VOLUMETRIA" }
    ]
    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Relatório de coletas resumido",
    });

    return (
        <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint} BtnAction1InTop={BtnExportCsv}>
            <CSVLink separator={";"} data={dadosRelatorio.listaColetas} headers={headersExport} filename="Relatorio de coletas resumido.csv" target="_blank" ref={exportRef}></CSVLink>
            <div className="mt-4 relatorio w-100" ref={refRelatorio}>
                <div className="print m-2 d-flex align-items-center justify-content-between">
                    <p>Emitido por: {session.nome}</p>
                    <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
                {setupVariavel?.logoTipo &&
                    <div className="d-flex align-items-center justify-content-center">
                        <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%'}} />
                    </div>
                }
                <div className="header">
                    <h4 className='text-black'>Relatório de coletas resumido</h4>
                    <Row>
                        <div className='col-4'>
                            <p><span className="fw-bold">Período:</span> {moment(filtros.dataInicial).format("DD/MM/YYYY")} à {moment(filtros.dataFinal).format("DD/MM/YYYY")}</p>
                        </div>
                        <div className='col-4'>
                            <p><span className="fw-bold">Status Coletas:</span> {filtros.status}</p>
                        </div>
                    </Row>
                    <Row>
                        <div className='col-4'>
                            {filtros.geradorId_selected
                                ?
                                <p><span className="fw-bold">Gerador:</span> {filtros.geradorId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Gerador:</span> Todos</p>
                            }
                        </div>
                        <div className='col-4'>
                            {filtros.modalidadeId_selected
                                ?
                                <p><span className="fw-bold">Modalidade:</span> {filtros.modalidadeId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Modalidade:</span> Todas</p>
                            }
                        </div>
                        <div className='col-4'>
                            {filtros.regionalId_selected
                                ?
                                <p><span className="fw-bold">Regional:</span> {filtros.regionalId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Regional:</span> Todas</p>
                            }
                        </div>
                    </Row>
                </div>
                <div className="body">
                    <h5 className='rounded-3 bg-secondary text-light p-2'>DADOS DO TRANSPORTADOR</h5>
                    <Row className='content-rel'>
                        <div className="col-6"><span className="fw-bold">Nome:</span> {dadosRelatorio.transportador.fantasia}</div>
                        <div className="col-6"><span className="fw-bold">CNPJ:</span> {dadosRelatorio.transportador.cnpj}</div>
                        <div className="col-4"><span className="fw-bold">Responsável:</span> {dadosRelatorio.transportador.responsavel}</div>
                        <div className="col-4"><span className="fw-bold">E-mail:</span> {dadosRelatorio.transportador.email}</div>
                        <div className="col-4"><span className="fw-bold">Telefone:</span> {dadosRelatorio.transportador.fone}</div>
                        <div className="col-4"><span className="fw-bold">CEP:</span> {dadosRelatorio.transportador.cep}</div>
                        <div className="col-4"><span className="fw-bold">Cidade:</span> {dadosRelatorio.transportador.cidade}</div>
                        <div className="col-4"><span className="fw-bold">UF:</span> {dadosRelatorio.transportador.uf}</div>
                        <div className="col-4"><span className="fw-bold">Bairro:</span> {dadosRelatorio.transportador.bairro}</div>
                        <div className="col-4"><span className="fw-bold">Rua:</span> {dadosRelatorio.transportador.logradouro}</div>
                        <div className="col-4"><span className="fw-bold">Numero:</span> {dadosRelatorio.transportador.numero}</div>
                    </Row>
                    <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>COLETAS</h5>
                    <CardRelatorio headers={headersColetas} items={dadosRelatorio.listaColetas} />

                </div>
            </div>
        </MainCard>
    )
}